import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Box, CircularProgress, Grid, IconButton, Modal, Pagination } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { fetchPicture, fetchAllEvents, fetchPicturesByEvent } from "../components/apifa";
import * as C from "../componentsM/index";
const Gallery = () => {
  const [events, setEvents] = useState([]);
  const [pictures, setPictures] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState("Main");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [open, setOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  useEffect(() => {
    const getEvents = async () => {
      try {
        const eventData = await fetchAllEvents();
        setEvents(["Main", ...eventData]);
        handleEventChange("Main", 1); // Load Main pictures on mount
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };
    getEvents();
  }, []);

  const handleEventChange = async (event, newPage = 1) => {
    setSelectedEvent(event);
    setPage(newPage);
    setLoading(true);
    try {
      const response = event === "Main" ? await fetchPicture(newPage) : await fetchPicturesByEvent(event, newPage);
      setPictures(response.results);
      setTotalPages(Math.ceil(response.count / 16));
    } catch (error) {
      console.error("Error fetching pictures:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    handleEventChange(selectedEvent, value);
  };

  return (
    <>
     <C.Hero
        title={"GALLERY"}
        tagLine={"The International School (TIS) Established In 1996"}
        image={"/hero/history.jpg"}
      />
      <Box style={{ marginBottom: "20px" }}>
        <AppBar position="static" style={{ backgroundColor: "rgba(210, 207, 207, 0.6)", backdropFilter: "blur(30px)", boxShadow: "none" }}>
          <Toolbar style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "8px" }}>
            {events.map((event) => (
              <span key={event} onClick={() => handleEventChange(event)} style={{ cursor: "pointer", fontWeight: "bold", color: "#ffd83a" }}>{event}</span>
            ))}
          </Toolbar>
        </AppBar>
      </Box>

      {loading ? (
        <div style={{ textAlign: "center", margin: "20px" }}><CircularProgress /></div>
      ) : (
        <Grid container spacing={2} style={{ padding: "20px" }}>
          {pictures.map((picture, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <div style={{ border: "1px solid #ddd", borderRadius: "10px", overflow: "hidden" }}>
                <img src={picture.image_url} alt="" style={{ width: "100%", height: "200px", objectFit: "cover", cursor: "pointer" }} onClick={() => { setCurrentImage(picture.image_url); setOpen(true); }} />
              </div>
            </Grid>
          ))}
        </Grid>
      )}

      <Pagination count={totalPages} page={page} onChange={handlePageChange} style={{ marginTop: "20px", display: "flex", justifyContent: "center" }} />

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", outline: "none" }}>
          <img src={currentImage} alt="Expanded" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
          <IconButton onClick={() => setOpen(false)} sx={{ position: "absolute", top: "10px", right: "10px", color: "#ffD63A" }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Modal>
    </>
  );
};

export default Gallery;